import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiClaimDynamicReward } from "@/api";
import {
  ClaimDynamicRewardResultCode,
  type ClaimDynamicRewardResponse,
} from "@/api/types";

/** 一次性领取全部可领团队动态奖励 */
export function useClaimDynamicReward() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (): Promise<ClaimDynamicRewardResponse> => {
      const res = await ApiClaimDynamicReward({});
      return res.data;
    },
    onSuccess: data => {
      if (!data.ok) return;
      queryClient.invalidateQueries({ queryKey: ["userDynamicRewardInfo"] });
      queryClient.invalidateQueries({
        queryKey: ["userDynamicRewardClaimRecords"],
      });
      queryClient.invalidateQueries({ queryKey: ["balanceV2"] });
    },
    onSettled: data => {
      if (data?.resultCode === ClaimDynamicRewardResultCode.PendingChanged) {
        queryClient.invalidateQueries({ queryKey: ["userDynamicRewardInfo"] });
      }
    },
  });
}
